<template>
  <div>
    <img src="../../assets/wxUser/top.jpg" class="topImg" />
    <van-cell-group>
      <van-field
        v-model="data.cName"
        required
        label="个人姓名"
        placeholder="请输入用户名"
        :readonly="readFlag"
      />
      <van-field
        v-model="data.cPhone"
        required
        label="联系电话"
        type="tel"
        placeholder="请输入手机号"
        :readonly="readFlag"
      />
      <van-field
        v-model="data.cInstallAddress"
        required
        label="购买地址"
        placeholder="请输入购买地址"
        :readonly="readFlag"
      />
      <van-field
        v-model="data.cProductName"
        required
        label="产品名称"
        placeholder="请输入产品名称"
        readonly
      />
      <van-field
        v-model="data.cProductStandard"
        required
        label="产品规格"
        placeholder="请输入产品规格"
        readonly
      />
      <van-field
        v-model="data.fCode"
        required
        label="防伪码"
        placeholder="请输入防伪码"
        readonly
      />
      <van-field
        v-model="data.fPrice"
        required
        label="产品价格"
        placeholder="请输入产品价格"
        :readonly="readFlag"
      />
      <van-field
        v-model="data.cBusiness"
        required
        label="商家名称"
        placeholder="请输入商家名称"
        :readonly="readFlag"
      />
      <van-field
        v-model="data.cBusinessPhone"
        required
        label="商家号码"
        type="tel"
        placeholder="请输入商家号码"
        :readonly="readFlag"
      />
      <van-field
        v-model="data.cBuyAddress"
        required
        label="商家地址"
        placeholder="请输入商家地址"
        :readonly="readFlag"
      />
      <van-field
        v-model="data.tBuyDate"
        required
        label="购买时间"
        placeholder="请选择购买时间"
        readonly
        @click="showDate()"
      />
    </van-cell-group>
    <van-popup v-model="show" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onConfirm"
        @cancel="onCancel"
      />
    </van-popup>
    <div class="subBtn" v-show="!readFlag" @click="subForm">提交</div>
  </div>
</template>

<script>
import {
  Toast,
  Cell,
  CellGroup,
  Field,
  DatetimePicker,
  Popup,
  Dialog,
} from "vant";

export default {
  data() {
    return {
      data: {
        cName: "",
        cPhone: "",
        cInstallAddress: "",
        cProductName: "",
        cProductStandard: "",
        fCode: "",
        fPrice: "",
        cBusiness: "",
        cBusinessPhone: "",
        cBuyAddress: "",
        tBuyDate: "",
      },
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      show: false,
      readFlag: false,
    };
  },
  components: {
    [Toast.name]: Toast,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [DatetimePicker.name]: DatetimePicker,
    [Popup.name]: Popup,
    [Dialog.name]: Dialog,
  },
  methods: {
    formatDate(date) {
      return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
    },
    showDate() {
      if (!this.readFlag) {
        this.show = true;
      }
    },
    onCancel() {
      this.show = false;
    },
    onConfirm(value) {
      console.log(value);
      this.data.tBuyDate = this.formatDate(value);
      this.show = false;
    },
    getProdData() {
      var _this = this;
      this.$get("/api/PhoneAPI/GetProductInfoModelByCode", {
        fCode: this.$route.query.fwm,
      })
        .then((res) => {
          if (res.IsSucceed) {
            _this.data.cProductName = res.Content.cProductName;
            _this.data.cProductStandard = res.Content.cStandard;
            _this.data.cProductName = res.Content.cProductName;
          } else {
            Toast(res.Message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    subForm() {
      var _this = this;
      if (this.data.cName == "") {
        Toast("请输入个人姓名");
        return;
      }
      if (this.data.cPhone == "") {
        Toast("请输入个人手机号码");
        return;
      }
      if (this.data.cInstallAddress == "") {
        Toast("请输入个人地址");
        return;
      }
      if (this.data.fPrice == "") {
        Toast("请输入产品价格");
        return;
      }
      if (this.data.cBusiness == "") {
        Toast("请输入商家名称");
        return;
      }
      if (this.data.cBusinessPhone == "") {
        Toast("请输入商家号码");
        return;
      }
      if (this.data.cBuyAddress == "") {
        Toast("请输入商家地址");
        return;
      }
      if (this.data.tBuyDate == "") {
        Toast("请选择购买时间");
        return;
      }
      this.$post("/api/PhoneAPI/AddAfterRegister", _this.data)
        .then((res) => {
          if (res.IsSucceed) {
            Dialog.alert({
              message: res.Message,
            }).then(() => {
              // on close
              location.reload();
            });
          } else {
            Toast(res.Message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.data.fCode = this.$route.query.fwm;
    var _this = this;

    this.$get("/api/PhoneAPI/GetAfterRegisterModel", {
      fCode: this.$route.query.fwm,
    })
      .then((res) => {
        if (res.IsSucceed) {
          if (res.Content.id == 0) {
            _this.readFlag = false;
            _this.getProdData();
          } else {
            _this.readFlag = true;
            _this.data=res.Content;
            _this.data.tBuyDate=res.Content.tBuyDate.split("T")[0];
          }
        } else {
          Toast(res.Message);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  created() {},
};
</script>

<style scoped>
.topImg {
  width: 375px;
}
.subBtn {
  width: 200px;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  background: #e62129;
  color: white;
  margin: 40px auto;
  border-radius: 5px;
}
</style>
